module.exports = __webpack_public_path__ + "img/bmsHome-xs.b8cea344.jpg";